import { makeStyles } from "@material-ui/core/styles";
import { colorsLight } from "../themes/colors";
/**
 * Style overrides for Network check status displays
 */
export const useNetworkCheckStatusStyles = makeStyles((theme) => ({
  oonStatusContainerRoot: {
    display: "flex",
    paddingLeft: 8,
    paddingRight: 8,
    paddingBottom: 8,
  },
  oonStatusContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(-1),
    marginTop: theme.spacing(-0.25),
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    marginRight: "8px",
  },
  verticallyCenteredContainer: {
    display: "table",
    height: "18px",
    overflow: "hidden",
  },
  verticallyCenteredItem: {
    display: "table-cell",
  },
  oonStatusText: {
    fontFamily: "Figtree",
    fontWeight: 600,
    color: theme.palette.success.dark,
  },
  networkCheckRunningText: {
    fontFamily: "Figtree",
    fontWeight: 600,
    color: colorsLight.font.secondary,
  },
  unknownStatusText: {
    fontFamily: "Figtree",
    fontWeight: 600,
    color: colorsLight.font.light,
  },
  unknownStatusTextOutOfArea: {
    fontFamily: "Figtree",
    fontWeight: 600,
    color: colorsLight.warning.dark,
  },
  successIcon: {
    color: theme.palette.success.main,
    fontSize: "20px",
  },
  unknownIcon: {
    color: colorsLight.font.light,
    fontSize: "20px",
  },
  errorIcon: {
    color: theme.palette.warning.dark,
    fontSize: "20px",
  },
  cancelIcon: {
    color: theme.palette.error.dark,
    fontSize: "20px",
  },
  warningOonStatusText: {
    fontFamily: "Figtree",
    fontWeight: 600,
    color: theme.palette.warning.dark,
    fontSize: "15px",
  },
  errorOonStatusText: {
    fontFamily: "Figtree",
    fontWeight: 600,
    color: theme.palette.error.dark,
    fontSize: "15px",
  },
  networkCheckCaptionContainer: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingBottom: 8,
  },
  networkCheckCaption: {
    color: colorsLight.font.secondary,
  },
}));
